import React from 'react';
import { connect } from 'react-redux';

import {
  getOfferErrorCode,
} from '../../reducers/ProductReducers';

const OfferErrorBlock = ({ errorCode }) => (
  <div className="push--bottom">
    <div className="error-message-block offer-error-block">
      <div className="strong soft--bottom">
        Error Code {errorCode}
      </div>
      <div style={{ lineHeight: '1.2em' }}>
        <span>Please see the </span>
        <a
          target="_blank" rel="noreferrer"
          href="https://support.instamojo.com/hc/en-us/articles/210818569-Error-codes"
          className="strong"
          style={{ color: '#E83C58', borderBottom: '1px solid' }}>
          error code table
        </a>
        <span> to debug the issue.</span>
      </div>
    </div>
  </div>
);

const mapStateToProps = ({ product }) => ({
  errorCode: getOfferErrorCode(product),
});

export default connect(mapStateToProps)(OfferErrorBlock);



// WEBPACK FOOTER //
// ./src/product/views/_layout/OfferErrorBlock.js